module.exports = __webpack_public_path__ + "static/media/Begoña_Villacís_Cs.2887c1ab.png";